import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import { changePasswordSchema } from "helpers/yup_validator";
import { useResetPasswordMutation } from "store/services/user.service";
import eye_open from "../../../../../../../Assets/svg/show_eye_icon.svg";
import eye_closed from "../../../../../../../Assets/svg/hide_eye_icon.svg";
import toast from "react-hot-toast";

const ChangePassword = ({ onCancel }) => {
  const [resetPassword] = useResetPasswordMutation();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSave = async (values, { resetForm }) => {
    try {
      await resetPassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      }).unwrap();
      toast.success("Password Updated Successfully");
      resetForm();
      onCancel();
    } catch (error) {
      console.error("Error updating password", error);
      toast.error(error?.data?.message);
    }
  };

  return (
    <Formik
      initialValues={{
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }}
      validationSchema={changePasswordSchema}
      onSubmit={handleSave}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col lg="6" className="my-3">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <Field
                    type={showCurrentPassword ? "text" : "password"}
                    name="currentPassword"
                    className="form-control"
                    placeholder="Current Password"
                    value={values.currentPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="icn position-absolute"
                    style={{ right: "8px", cursor: "pointer" }}
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  >
                    <img
                      src={showCurrentPassword ? eye_open : eye_closed}
                      alt=""
                    />
                  </span>
                </div>
                <label
                  htmlFor="currentPassword"
                  className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                >
                  Current Password
                </label>
                <ErrorMessage
                  name="currentPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>
            <Col lg="6" className="my-3">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <Field
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    className="form-control"
                    placeholder="New Password"
                    value={values.newPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="icn position-absolute"
                    style={{ right: "8px", cursor: "pointer" }}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <img src={showNewPassword ? eye_open : eye_closed} alt="" />
                  </span>
                </div>
                <label
                  htmlFor="newPassword"
                  className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                >
                  New Password
                </label>
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>
            <Col lg="6" className="my-3">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <Field
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    value={values.confirmPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="icn position-absolute"
                    style={{ right: "8px", cursor: "pointer" }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <img
                      src={showConfirmPassword ? eye_open : eye_closed}
                      alt=""
                    />
                  </span>
                </div>
                <label
                  htmlFor="confirmPassword"
                  className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                >
                  Confirm Password
                </label>
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>
            <Col lg="7" className="my-2">
              <div className="d-flex align-items-center gap-10 btnWrpperGroup">
                <Button
                  type="button"
                  className="d-inline-flex align-items-center justify-content-center commonBtn cancelBtn w-100"
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="d-inline-flex align-items-center justify-content-center commonBtn w-100"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default ChangePassword;
